import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, ContainerBody, ViewFormsButton, ViewFormsDropdrown } from './styles';

export const YearEndFormCardItem: React.FC<{
  title: string;
  formsLoaded: string;
  formsIssued: string;
  year: string;
  formType: string;
}> = ({ title, formsLoaded, formsIssued, year, formType }) => {
  const navigate = useNavigate();
  return (
    <Container>
      <div>
        <h3>{title}</h3>
      </div>
      <ContainerBody>
        <ViewFormsDropdrown
          disabled
          setValue={() => {}}
          label="Form set Status"
          options={[{ key: '1', value: 'ready', label: 'Ready' }]}
        />
        <ViewFormsDropdrown
          disabled
          setValue={() => {}}
          label="Forms loaded"
          options={[{ key: '1', value: formsLoaded, label: formsLoaded }]}
        />
        <ViewFormsDropdrown
          disabled
          setValue={() => {}}
          label="Forms Issued"
          options={[{ key: '1', value: formsIssued, label: formsIssued }]}
        />
        <ViewFormsDropdrown
          disabled
          setValue={() => {}}
          label="E-File Submitted"
          options={[{ key: '1', value: '1', label: '-- --' }]}
        />
        <ViewFormsButton
          onClick={() => {
            navigate(`/year-end-forms/${year}/${formType}`);
          }}
        >
          View Forms
        </ViewFormsButton>
      </ContainerBody>
    </Container>
  );
};
